'use client';

import React from 'react';
import { SearchBar } from './SearchBar';

/**
 * Desktop home search. Delegates to `SearchBar`, which renders the AI rent search
 * (bar + header mini bar + expanded tabbed overlay) when `/ai-search/status/`
 * isn't `disabled`, and otherwise falls back to the legacy listings search. The
 * reviews tab always keeps the legacy building search.
 */
export function HomeSearch() {
  return <SearchBar />;
}

export default HomeSearch;
